import { axiosApi } from "../lib/axios";
import { decryptData } from "../utils/encryptDecrypt";

//Api call for fetching provider details for hire me functionality
export const fetchProviderDetails = async (payload) => {
  try {
    const response = await axiosApi.post("/api/user/findById", payload);

    const decrypt = await decryptData(response.data);

    response.data = decrypt;
    return response;
  } catch (error) {
    // Error handled silently
  }
};

//Api call for block user
export const blockUser = async (payload) => {
  try {
    return await axiosApi.post("/api/user/blockUser", payload);
  } catch (error) {
    // Error handled silently
  }
};

//Api call for unblock user
export const unblockUser = async (payload) => {
  try {
    return await axiosApi.post("/api/user/unblockUser", payload);
  } catch (error) {
    // Error handled silently
  }
};

//Api call for unblock user
export const fetchBlockStatus = async (payload) => {
  try {
    return await axiosApi.post("/api/user/getBlockStatus", payload);
  } catch (error) {
    // Error handled silently
  }
};

export const fetchImg = async (payload) => {
  try {
    return await axiosApi.post(`generate-presigned-url/${payload}`);
  } catch (error) {
    // Error handled silently
  }
};
